import { Component, Input } from '@angular/core';
import { StateService } from '@uirouter/angular';

@Component({
  selector: 'gf-checks-result-list',
  template: `<div class="list-group" *ngIf="results">
  <em *ngIf="!results.length" translate>No results available</em>
  <a *ngFor="let item of results"
      class="list-group-item"
      (click)="go(item.id)">
      <h4 class="list-group-item-heading truncate-text" [title]="item.name">
          <gf-glyph class="glyph-xs glyph-img-group-3"></gf-glyph>
          <span style="margin-left: .5em;">{{ item.name }}</span>
      </h4>
      <p class="list-group-item-text">{{ item.createDate | gfDate: 'LL' }}</p>
  </a>
</div>`
})
export class ChecksResultListComponent {
  @Input() results: any;

  constructor(private stateService: StateService) {
  }

  go(id: any) {
    this.stateService.go('.', {id: id});
  }
}
